import React from 'react';

export function getClearClass(idx) {
  const cn = `clearfix${idx % 4 === 3 ? ' visible-xs-block visible-sm-block visible-md-block' : ''}${idx % 4 === 3 ? '  visible-lg-block' : ''}`;
  if (cn !== 'clearfix') {
    return <div className={cn} />;
  }
  return false;
}

export default getClearClass;




/** WEBPACK FOOTER **
 ** ./src/components/util/themeClearClass.jsx
 **/